<template>
    <v-layout wrap>
        <v-flex class="mb-1 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('aid-information-list') }}</h1>
                <v-tooltip bottom>
                    <v-btn flat icon slot="activator">
                        <v-icon>mdi-help-circle</v-icon>
                    </v-btn>
                    <span>{{ $t('help') }}</span>
                </v-tooltip>
                <!--<v-tooltip bottom>
                    <v-btn @click="OpenReport()" flat icon slot="activator">
                        <v-icon>mdi-file-chart</v-icon>
                    </v-btn>
                    <span>{{ $t('report') }}</span>
                </v-tooltip>-->
            </div>
            <!-- Actions -->
            <div class="text-xs-right">
                <v-btn :to="{ name: 'add-aid-information' }" color="success" v-can:add>
                    <v-icon left>add</v-icon>
                    {{ $t('add-new-aid-information') }}
                </v-btn>
                <v-menu bottom left min-width="100" origin="center center" transition="scale-transition" v-if="selected.length">
                    <v-btn flat icon slot="activator">
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list>
                        <v-list-tile @click="deleteBeneficiaryInformationManagements" v-can:delete>
                            <v-list-tile-title>{{ $t('delete') }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="postBeneficiaryInformationManagements" v-can:post>
                            <v-list-tile-title>{{ $t('post') }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="unpostBeneficiaryInformationManagements" v-can:unpost>
                            <v-list-tile-title>{{ $t('unpost') }}</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </div>
        </v-flex>
        <!-- Sarch Form -->
        <!-- TODO: Add search box -->
        <v-flex xs12>
            <v-card class="pa-2 pt-3 mb-3">
                <v-form @submit.prevent="getBeneficiaryInformations">
                    <v-layout wrap>
                        <v-flex md2 sm6 xs12 px-2>
                            <v-text-field :label="$t('national-number')" v-model="filter.beneficiaryNationalNumJOR"></v-text-field>
                        </v-flex>
                        <!--<v-flex md2 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('select-gender')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="gendersList"
                                            :label="$t('select-gender')"
                                            :name="'gender'"
                                            clearable
                                            item-value="code"
                                            v-model="filter.gender"></v-autocomplete>
                        </v-flex>-->
                        <!--<v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('social-status')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="socialStatusesList"
                                            :label="$t('social-status')"
                                            :name="'socialStatus'"
                                            clearable
                                            item-value="code"
                                            v-model="filter.socialStatus"></v-autocomplete>
                        </v-flex>-->
                        <!--<v-flex md2 sm6 xs12 px-2>
                            <v-autocomplete item-text="name"
                                            :items="nationalityList"
                                            :label="$t('nationality-lookUpCode')"
                                            clearable
                                            item-value="code"
                                            name="nationalityLookUpCode"
                                            v-model="filter.nationalityLookUpCode"></v-autocomplete>
                        </v-flex>-->
                        <v-flex md2 px-2 sm6 xs12>
                            <v-text-field :label="$t('full-name')" name="fullName" v-model="filter.fullName"></v-text-field>
                        </v-flex>
                        <v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('governorate')"
                                            :error-messages="errors.collect(formScope + '.governoratecity')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="governoratesList"
                                            :label="$t('governorate')"
                                            clearable
                                            item-value="code"
                                            name="governoratecity"
                                            v-model="filter.governorate"></v-autocomplete>
                        </v-flex>
                        <!--<v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :label="$t('Aging')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :name="'Aging'"
                                            :items="AgingList"
                                            clearable
                                            item-value="code"
                                            v-model="filter.Aging"></v-autocomplete>
                        </v-flex>-->
                        <v-flex xs12>
                            <v-btn color="primary" type="submit">{{ $t('filter') }}</v-btn>
                            <v-btn color="primary" type="reset" @click="filterInit()">{{ $t('reset') }}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card>
        </v-flex>
        <!-- Data Table -->
        <v-flex xs12>
            <v-data-table :headers="headers"
                          :items="beneficiaryInformationManagements"
                          :loading="isLoading"
                          :rows-per-page-items="[10, 25, { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }]"
                          class="elevation-1"
                          select-all
                          v-model="selected">
                <template slot="items" slot-scope="props">
                    <tr :key="props.index" :class="props.item.isActive ? '' : 'is-posted'">
                        <td>
                            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td>{{ props.item.fullName }}</td>
                        <td>{{ props.item.beneficiaryNationalNumJOR }}</td>
                        <!--<td>{{ tableFormat('nationalityList', props.item.nationalityLookUpCode) }}</td>
                <td>{{ props.item.fatherNationalNo }}</td>
                <td>{{ props.item.nationalNumforMUM }}</td>
                <td>{{ props.item.bod | date }}</td>-->
                        <td>
                            <v-btn icon v-can:edit :to="{ name: 'edit-aid-information', params: { id: props.item.id } }">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </td>
                        <td>
                            <v-icon v-show="props.item.isActive">mdi-account-check mdi-36px</v-icon>
                            <v-icon v-show="!props.item.isActive">mdi-check-outline</v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <!--<v-btn color="primary" type="reset" @click="deleteBeneficiaryInformationManagements()">{{ $t('delete') }}</v-btn>-->
        </v-flex>
    </v-layout>
</template>

<script>
    import { ConfirmationEvent } from '@/components/Confirmation/ConfirmationEventBus';
    import BeneficiaryInformationManagementService from '@/services/Disabilities/PersonWithDisabilities/BeneficiaryInformationManagement/BeneficiaryInformationManagement/BeneficiaryInformationManagementService';
    import LookUpService from '@/services/LookUpService';
    import DefinitionOfDiseasesService from '@/services/Disabilities/PersonWithDisabilities/DefinitionOfDiseasesService';
    export default {
        name: 'aid-information-list',
        data() {
            return {
                selected: [],
                beneficiaryInformationManagements: [],
                isLoading: false,
                filter: {},
                nationalityList: [],
                regionsList: [],
                governoratesList: [],
                socialStatusesList: [],
                educationalLevelsList: [],
                diseasesList: [],
                gendersList: [],
                AgingList: [],
                jobSectorsList: [],
                selectedDiseases: [],
                dialog: false,
                beneficiaryInformationManagementsForPopup: []
            };
        },
        async created() {
            this.$store.dispatch('showLoading');
            await this.getNationlites();
            await this.getGenders();
            await this.getSocialStatuses();
            await this.getEducationalLevels();
            await this.getAgingList();
            await this.getGovernorates();
            await this.getJobSectors();
            this.$store.dispatch('hideLoading');
            this.filterInit();
        },
        methods: {
            async filterInit() {
                this.filter = {
                    keyword: '',
                    beneficiaryNationalNumJOR: '',
                    nationalityLookUpCode: '',
                    fullName: '',
                    nameMUM: '',
                    nationalNumforMUM: '',
                    gender: '0',
                    socialStatus: '0',
                    educationalLevel: '0',
                    fatherNationalNo: '',
                    jobSector: '',
                    pageCode: '202',
                    typeOfDisability:'',
                };

                await this.getBeneficiaryInformations();
                await this.getGovernorates();
                await this.getDiseasesByType();
            },
            getAgingList() {
                this.AgingList.push(
                    {
                        code: 1,
                        name: 'الاطفال'
                    },
                    {
                        code: 2,
                        name: 'سن المدرسه'
                    },
                    {
                        code: 3,
                        name: 'سن العمل'
                    }
                    ,
                    {
                        code: 4,
                        name: 'فوق سن العمل'
                    }
                );
            },
            /* Get all BeneficiaryInformationManagements info */
            async getBeneficiaryInformations() {
                this.isLoading = true;
                const beneficiaryInformationManagements = (await BeneficiaryInformationManagementService.getBeneficiaryInformationManagements(
                    this.filter
                )).data;
                this.beneficiaryInformationManagements = beneficiaryInformationManagements;
                this.isLoading = false;
            },

            /* Delete BeneficiaryInformationManagement */
            deleteBeneficiaryInformationManagements() {
                this.$store.dispatch('confirm');
                ConfirmationEvent.$on('onSuccess', async () => {
                    /* Show loading on delete BeneficiaryInformationManagements */
                    this.$store.dispatch('showLoading');
                    const result = await BeneficiaryInformationManagementService.deleteBeneficiaryInformationManagements(this.selectedIds);
                    this.selected = [];
                    this.$store.dispatch('hideLoading');
                    if (result.data.statusCode === 200) {
                        var firstIndexOf = result.data.message.indexOf('(') + 1;
                        var lastIndexOf = result.data.message.indexOf(')');
                        var BeneficiaryInformationManagementNames = result.data.message.substring(firstIndexOf, lastIndexOf);
                        var arrayNames = BeneficiaryInformationManagementNames.split(',');
                        var displayString = `${this.$t('delete')} `;
                        arrayNames.forEach((beneficiaryInformationManagement, index) => {
                            displayString += `\n ${index + 1} - ${beneficiaryInformationManagement}`;
                        });
                        this.$store.dispatch('showMessage', {
                            text: displayString,
                            multiLine: true
                        });
                    } else {
                        this.$store.dispatch('showMessage', {
                            text: result.data.message,
                            color: 'error'
                        });
                    }
                    await this.getBeneficiaryInformations();
                });
            },

            /* Post BeneficiaryInformationManagements */
            async postBeneficiaryInformationManagements() {
                let postBeneficiaryInformation = [];
                for (let i = 0; i < this.selected.length; i++) {
                    postBeneficiaryInformation.push({ id: this.selectedIds[i].id, isActive: true });
                }
                const result = await BeneficiaryInformationManagementService.postBeneficiaryInformationManagements(postBeneficiaryInformation);
                this.selected = [];
                if (result.data.statusCode === 200) {
                    const firstIndexOf = result.data.message.indexOf('(') + 1;
                    const lastIndexOf = result.data.message.indexOf(')');
                    const message = result.data.message.substring(0, firstIndexOf - 1);
                    const namesList = result.data.message.substring(firstIndexOf, lastIndexOf).split(',');
                    let namesAfterLoop = '<ol>';
                    namesList.forEach(item => {
                        namesAfterLoop += `<li>${item}</li>`;
                    });
                    namesAfterLoop += '</ol>';
                    this.$store.dispatch('showMessage', {
                        text: message + '</br>' + namesAfterLoop,
                        multiLine: true
                    });
                } else {
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                }
                await this.getBeneficiaryInformations();
            },

            /* Un Post BeneficiaryInformationManagements */
            async unpostBeneficiaryInformationManagements() {
                let postBeneficiaryInformation = [];
                for (let i = 0; i < this.selected.length; i++) {
                    postBeneficiaryInformation.push({ id: this.selectedIds[i].id, isActive: false });
                }
                const result = await BeneficiaryInformationManagementService.postBeneficiaryInformationManagements(postBeneficiaryInformation);
                this.selected = [];
                if (result.data.statusCode === 200) {
                    const firstIndexOf = result.data.message.indexOf('(') + 1;
                    const lastIndexOf = result.data.message.indexOf(')');
                    const message = result.data.message.substring(0, firstIndexOf - 1);
                    const namesList = result.data.message.substring(firstIndexOf, lastIndexOf).split(',');
                    let namesAfterLoop = '<ol>';
                    namesList.forEach(item => {
                        namesAfterLoop += `<li>${item}</li>`;
                    });
                    namesAfterLoop += '</ol>';
                    this.$store.dispatch('showMessage', {
                        text: message + '</br>' + namesAfterLoop,
                        multiLine: true
                    });
                } else {
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                }
                await this.getBeneficiaryInformations();
            },
            async getNationlites() {
                this.nationalityList = (await LookUpService.getLookup(55)).data;
            },
            async getDiseasesByType() {
                this.diseasesList = (await DefinitionOfDiseasesService.getDefinitionOfDiseasesByCriteria()).data;
            },
            async getGenders() {
                this.gendersList = (await LookUpService.getLookup(59)).data;
            },
            async getGovernorates() {
                this.governoratesList = (await LookUpService.getLookup(62)).data;
            },
            async getSocialStatuses() {
                this.socialStatusesList = (await LookUpService.getLookup(77)).data;
            },
            async getEducationalLevels() {
                this.educationalLevelsList = (await LookUpService.getLookup(54)).data;
            },
            async getJobSectors() {
                this.jobSectorsList = (await LookUpService.getLookup(84)).data;
            },
            tableFormat(arrayName, code) {
                const item = this[arrayName].find(item => item.code === code);
                return item ? item.name : code;
            },
            OpenReport() {
                var beneficiaryNationalNumJOR = this.filter.beneficiaryNationalNumJOR;
                var gender = this.filter.gender;
                var socialStatus = this.filter.socialStatus;
                var educationalLevel = this.filter.educationalLevel;
                var nationalityLookUpCode = this.filter.nationalityLookUpCode;
                var fullName = this.filter.fullName;
                var nationalNumforMUM = this.filter.nationalNumforMUM;
                var fatherNationalNo = this.filter.fatherNationalNo;
                var governorate = this.filter.governorate;
                var aging = this.filter.Aging;
                var jobSector = this.filter.jobSector;

                if (this.filter.jobSector == '' || this.filter.jobSector == null) {
                    jobSector = "0";
                }

                if (this.filter.Aging == '' || this.filter.Aging == null) {
                    aging = "0";
                }

                if (this.filter.governorate == '' || this.filter.governorate == null) {
                    governorate = "0";
                }

                if (this.filter.fullName == '' || this.filter.fullName == null) {
                    fullName = "0";
                }

                if (this.filter.nationalNumforMUM == '' || this.filter.nationalNumforMUM == null) {
                    nationalNumforMUM = "0";
                }

                if (this.filter.fatherNationalNo == '' || this.filter.fatherNationalNo == null) {
                    fatherNationalNo = "0";
                }

                if (this.filter.beneficiaryNationalNumJOR == '' || this.filter.beneficiaryNationalNumJOR == null) {
                    beneficiaryNationalNumJOR = "0";
                }

                if (this.filter.gender == '' || this.filter.gender == null) {
                    gender = "0";
                }

                if (this.filter.socialStatus == '' || this.filter.socialStatus == null) {
                    socialStatus = "0";
                }

                if (this.filter.educationalLevel == '' || this.filter.educationalLevel == null) {
                    educationalLevel = "0";
                }

                if (this.filter.nationalityLookUpCode == '' || this.filter.nationalityLookUpCode == null) {
                    nationalityLookUpCode = "0";
                }

                window.open('http://10.196.11.59:9494/HCDreport/Pages/BeneficiaryInfolistReport.aspx?beneficiaryNationalNumJOR=' + beneficiaryNationalNumJOR + '&gender=' + gender +
                    '&socialStatus=' + socialStatus + '&educationalLevel=' + educationalLevel + '&nationalityLookUpCode=' + nationalityLookUpCode +
                    '&fullName=' + fullName + '&nationalNumforMUM=' + nationalNumforMUM + '&fatherNationalNo=' + fatherNationalNo
                    + '&governorate=' + governorate + '&aging=' + aging + '&jobSector=' + jobSector
                    , '_blank');
            },

            /* getBeneficaryByCreteriasForPopup */
            /* Get all getBeneficaryByCreteriasForPopup info */
            async getBeneficiaryInformationsForPopup() {
                this.isLoading = true;
                const beneficiaryInformationManagements = (await BeneficiaryInformationManagementService.getBeneficiaryInformationManagements(
                    this.filter
                )).data;
                this.beneficiaryInformationManagementsForPopup = beneficiaryInformationManagements;
                this.isLoading = false;
            },

            /* filterinit */
            async filterInitForPopup() {
                this.filter = {
                    keyword: '',
                    beneficiaryNationalNumJOR: '',
                    nationalityLookUpCode: '',
                    fullName: '',
                    nameMUM: '',
                    nationalNumforMUM: '',
                    gender: '0',
                    socialStatus: '0',
                    educationalLevel: '0',
                    fatherNationalNo: ''
                };
                await this.getBeneficiaryInformationsForPopup();
            },

            async chosen(beneficiary) {
                this.dialog = false;
                this.filter = {
                    keyword: '',
                    beneficiaryNationalNumJOR: beneficiary.beneficiaryNationalNumJOR,
                    nationalityLookUpCode: beneficiary.nationalityLookUpCode,
                    fullName: beneficiary.fullName,
                    nameMUM: beneficiary.nameMUM,
                    nationalNumforMUM: beneficiary.nationalNumforMUM,
                    gender: beneficiary.gender,
                    socialStatus: beneficiary.socialStatus,
                    educationalLevel: beneficiary.educationalLevel,
                    fatherNationalNo: beneficiary.fatherNationalNo
                };
            }
            /* end */
        },
        computed: {
            selectedIds() {
                return this.selected.map(beneficiaryInformationManagement => ({
                    id: beneficiaryInformationManagement.id
                }));
            },

            /* Query Tabel */
            headers() {
                return [
                    { text: this.$t('full-name'), value: 'fullName', sortable: false },
                    { text: this.$t('national-number'), value: 'beneficiaryNationalNumJOR', sortable: false },
                    //{ text: this.$t('nationality-lookUpCode'), value: 'nationalityLookUpCode', sortable: false },
                    //{ text: this.$t('father-national-number'), value: 'fatherNationalNo', sortable: false },
                    //{ text: this.$t('mother-national-number'), value: 'nationalNumforMUM', sortable: false },
                    //{ text: this.$t('birth-date'), value: 'bod', sortable: false },
                    { text: this.$t('edit'), value: '', sortable: false },
                    { text: this.$t('PostStatus'), value: 'isActive', sortable: false }
                ];
            },

            /* Query Tabel */
            headersForPopup() {
                return [
                    { text: this.$t('full-name'), value: 'fullName', sortable: false },
                    { text: this.$t('national-number'), value: 'beneficiaryNationalNumJOR', sortable: false },
                    { text: this.$t('nationality-lookUpCode'), value: 'nationalityLookUpCode', sortable: false },
                    { text: this.$t('father-national-number'), value: 'fatherNationalNo', sortable: false },
                    { text: this.$t('mother-national-number'), value: 'nationalNumforMUM', sortable: false },
                    { text: this.$t('birth-date'), value: 'bod', sortable: false },
                    { text: this.$t('chose'), value: '', sortable: false },
                ];
            }
        }
    };
</script>